import { HowToEarnScreen } from '@/screens/diamonds/HowToEarnScreen'

export default function () {
  return <HowToEarnScreen />
}
